import React from "react";
import { LineChart } from "@mui/x-charts/LineChart";
import processYearComparisonData, {
  generateMonthlyComparison,
} from "../../serviceFunctions/LandingPage/totalSalesInMonth";
import { useCommonDataContext } from "../../context/CommonDataProvider";
import useResizeObserver from './useResizeObserver';

const xLabels = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export default function TotalSalesLineChart({ apiData }) {
  let { stokistData } = useCommonDataContext();
  stokistData = stokistData ? stokistData : [];
  // const [selectedPlace, setSelectedPlace] = useState('Balaji');
  const currentYearData = processYearComparisonData(apiData[1], stokistData);
  const previousYearData = processYearComparisonData(apiData[2], stokistData);
  const monthlyComparison = generateMonthlyComparison(
    previousYearData,
    currentYearData
  );
  const [containerRef, { width }] = useResizeObserver();

  const cyear = new Date().getFullYear();
  const pyear = cyear - 1;

  return (
    <div ref={containerRef} className="w-full h-[350px]">
      <LineChart
        width={width || 300}
        height={350}
        margin={{ 
          left: width ? Math.min(80, width * 0.1) : 40,
          right: 20,
          top: 20,
          bottom: 30 
        }}
        dataset={monthlyComparison}
        series={[
          {
            label: pyear.toString(),
            dataKey: "previousYear",
            color: "var(--color-button)",
          },
          { 
            label: cyear.toString(), 
            dataKey: "currentYear", 
            color: "#42A5F5" 
          },
        ]}
        xAxis={[{ 
          scaleType: "point", 
          data: xLabels,
          tickLabelStyle: {
            angle: width && width < 500 ? 45 : 0,
            textAnchor: width && width < 500 ? 'start' : 'middle',
            fontSize: width && width < 400 ? 10 : 12
          }
        }]}
        slotProps={{
          legend: {
            direction: width && width < 600 ? 'column' : 'row',
            position: { 
              vertical: width && width < 600 ? 'top' : 'top',
              horizontal: 'middle'
            },
          }
        }}
      />
    </div>
  );
}
